
import { Comment } from '../types/comment';
import { ArrowLeft, ExternalLink } from 'lucide-react';

interface PostHeaderProps {
  comment: Comment;
}

const PostHeader = ({ comment }: PostHeaderProps) => {
  const platformText = comment.platform === 'youtube' ? 'YouTube' : comment.platform;
  
  return (
    <div className="border-b border-gray-200 dark:border-gray-700/50 p-4 flex items-center justify-between bg-white dark:bg-[#1a1d2d] transition-colors">
      <div className="flex items-center">
        <button 
          className="mr-4 p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          onClick={() => window.history.back()}
        >
          <ArrowLeft className="h-5 w-5 text-gray-600 dark:text-gray-300" />
        </button>
        
        <div>
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            {comment.videoTitle || 'Vidéo sans titre'}
          </h2>
          <div className="flex items-center mt-1">
            <span className="text-sm text-custom-primary dark:text-custom-secondaryLight font-medium">
              {platformText}
            </span>
            <span className="mx-2 text-gray-400">•</span>
            <span className="text-sm text-gray-600 dark:text-gray-400">
              Publié le {new Date(comment.timestamp).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
      
      {comment.videoId && (
        <a 
          href={`https://www.youtube.com/watch?v=${comment.videoId}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center text-custom-primary dark:text-custom-secondaryLight hover:underline"
        >
          <span className="mr-1 text-sm">Voir sur YouTube</span>
          <ExternalLink className="h-4 w-4" />
        </a>
      )}
    </div>
  );
};

export default PostHeader;
